import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { giftPluginReducers } from '@ff-scene-plugins/gift-redux/store';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { applyPrefabById } from './applyPrefabById';
import { close } from './close';
import { GiftDesignerUi } from './GiftDesignerUi';
import { GiftModalUi } from './GiftModalUi';
import { GiftPreviewUi } from './GiftPreviewUi';
import { renderProjectToThumbnail } from './renderProjectToThumbnail';
import { show } from './show';
import { addDesignChangeListener } from './startup/addDesignChangeListener';
import { getProjectExportStatus } from './startup/getProjectExportStatus';
import { initializeProject } from './startup/initializeProject';
import { openProject } from './startup/openProject';
import { startup } from './startup/startup';
import { toOutputs } from './toOutputs';

export const giftPdpPlugin: Pdp.Scene.Plugin<GiftJson.Project> = {

    pluginId: 'gift',

    ui: {
        designer: GiftDesignerUi,
        preview: GiftPreviewUi,
        modal: GiftModalUi
    },

    reducers: giftPluginReducers,
    startup: startup,

    show: show,
    close: close,
    applyPrefab: applyPrefabById,

    toOutputs: toOutputs,
    renderThumbnail: renderProjectToThumbnail,

    addDesignChangeListener: addDesignChangeListener,

    project: {
        initialize: initializeProject,
        open: openProject,
        getExportStatus: getProjectExportStatus
    }
};